import { createContext } from 'react';

const DropdownContext = createContext({
  hide() {},
});

export default DropdownContext;
